import ContentLoader from 'react-content-loader'
import {FC} from 'react'
import {colorCodes} from 'definitions/constant'

type Props = {
  width?: number | string
  classes?: string
  height?: number
}
export const LineSkeleton: FC<Props> = ({
  width = '100%',
  height = 10,
  classes,
}) => {
  return (
    <ContentLoader
      speed={2}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor={colorCodes.dopeGray1500}
      foregroundColor={colorCodes.dopeGray1200}
      className={classes}
    >
      <rect rx="5" ry="5" width={width} height={height} />
    </ContentLoader>
  )
}
